import Visibility from 'visibilityjs';
import { Sentry } from 'app/utils/sentry';
import { history } from 'store';
import * as conversationsActions from '../../../components/conversation/actions/conversations';
import { actions } from './actions/visibility';
const { visibilityStart, visibilityHidden, visibilityShown, visibilityStop } = actions;
const { conversationsResetUnread } = conversationsActions.actions;
export const visibilityMiddleware = () => (store) => {
    const next = store.dispatch;
    let listener = null;
    const initVisibility = () => {
        listener = Visibility.change(() => {
            var _a, _b, _c, _d;
            if (Visibility.hidden()) {
                let csid = null;
                // We look the the pathname to see if we are on conversation/{csid}.
                if (((_b = (_a = history.location) === null || _a === void 0 ? void 0 : _a.pathname) === null || _b === void 0 ? void 0 : _b.indexOf('conversation/')) > -1) {
                    // Get the csid from the pathname.
                    const pathnameArr = history.location.pathname.split('/conversation/');
                    if (pathnameArr.length > 0) {
                        csid = parseInt(pathnameArr[1]);
                    }
                }
                next(visibilityHidden({ csid: csid }));
            }
            else {
                const state = store.getState();
                let csid = null;
                // We look the the pathname to see if we are on conversation/{csid}.
                if (((_d = (_c = history.location) === null || _c === void 0 ? void 0 : _c.pathname) === null || _d === void 0 ? void 0 : _d.indexOf('conversation/')) > -1) {
                    // Get the csid from the pathname.
                    const pathnameArr = history.location.pathname.split('/conversation/');
                    if (pathnameArr.length > 0) {
                        csid = parseInt(pathnameArr[1]);
                        // match the state conversation csid with current path.
                        if (isNaN(csid) === false &&
                            state.conversation.metaConversation.conversation.id === csid) {
                            next(conversationsResetUnread({ csid: csid }));
                        }
                    }
                }
                next(visibilityShown({ csid: csid }));
            }
        });
        document.addEventListener('mouseleave', _mouseleave, false);
        document.addEventListener('mouseenter', _mouseenter, false);
        window.addEventListener('focus', _focusListener, false);
        window.addEventListener('blur', _blurListener, false);
    };
    const removeVisibility = () => {
        Visibility.unbind(listener);
        document.removeEventListener('mouseleave', _mouseleave, false);
        document.removeEventListener('mouseenter', _mouseenter, false);
        window.removeEventListener('focus', _focusListener, false);
        window.removeEventListener('blur', _blurListener, false);
    };
    const _mouseleave = () => {
        next(visibilityHidden());
    };
    const _mouseenter = () => {
        var _a, _b;
        const state = store.getState();
        let csid = null;
        // We look the the pathname to see if we are on conversation/{csid}.
        if (((_b = (_a = history.location) === null || _a === void 0 ? void 0 : _a.pathname) === null || _b === void 0 ? void 0 : _b.indexOf('conversation/')) > -1) {
            // Get the csid from the pathname.
            const pathnameArr = history.location.pathname.split('/conversation/');
            if (pathnameArr.length > 0) {
                csid = parseInt(pathnameArr[1]);
                // match the state conversation csid with current path.
                if (isNaN(csid) === false &&
                    state.conversation.metaConversation.conversation.id === csid) {
                    next(conversationsResetUnread({ csid: csid }));
                }
            }
        }
        next(visibilityShown({ csid: csid }));
    };
    const _focusListener = () => {
        var _a, _b;
        const state = store.getState();
        let csid = null;
        // We look the the pathname to see if we are on conversation/{csid}.
        if (((_b = (_a = history.location) === null || _a === void 0 ? void 0 : _a.pathname) === null || _b === void 0 ? void 0 : _b.indexOf('conversation/')) > -1) {
            // Get the csid from the pathname.
            const pathnameArr = history.location.pathname.split('/conversation/');
            if (pathnameArr.length > 0) {
                csid = parseInt(pathnameArr[1]);
                // match the state conversation csid with current path.
                if (isNaN(csid) === false &&
                    state.conversation.metaConversation.conversation.id === csid) {
                    next(conversationsResetUnread({ csid: csid }));
                }
            }
        }
        next(visibilityShown({ csid: csid }));
    };
    const _blurListener = () => {
        var _a, _b;
        let csid = null;
        // We look the the pathname to see if we are on conversation/{csid}.
        if (((_b = (_a = history.location) === null || _a === void 0 ? void 0 : _a.pathname) === null || _b === void 0 ? void 0 : _b.indexOf('conversation/')) > -1) {
            // Get the csid from the pathname.
            const pathnameArr = history.location.pathname.split('/conversation/');
            if (pathnameArr.length > 0) {
                csid = parseInt(pathnameArr[1]);
            }
        }
        next(visibilityHidden({ csid: csid }));
    };
    return (next) => (action) => {
        try {
            switch (action.type) {
                case visibilityStart.toString(): {
                    initVisibility();
                    break;
                }
                case visibilityStop.toString(): {
                    removeVisibility();
                    break;
                }
            }
        }
        catch (exception) {
            Sentry.captureException(new Error('Visibility: middleware exception catched'));
        }
        return next(action);
    };
};
